<!-- ONE side's hedge parameters (S5-S9). Instantiated twice: calls and puts. -->
<div class="side-block"
     [class.side-block--off]="!this.enabled"
     [class.side-block--closed]="!this.expanded"
     [attr.data-element]="'maven-side-' + this.side">

  <!-- A COLLAPSIBLE SECTION WITH THE CHECKBOX IN ITS HEADER (vrequest 2026-09-13, item 6).
       The side is OPENED explicitly. A side the trader never opened is not an incomplete side,
       and the Setup validation depends on being able to tell those two apart. Checking expands
       and unchecking collapses; the chevron expands or collapses on its own, without touching
       whether the side is used. -->
  <!-- .side-head--changed / .param-changed (owner vrequest 2026-09-15): something on this side, or
       the checkbox itself, no longer matches what the last run was sent with. -->
  <div class="side-head"
       [class.side-head--changed]="this.anyChanged"
       [attr.data-element]="'maven-side-head-' + this.side">
    <dx-check-box [value]="this.enabled"
                  [text]="this.title"
                  [disabled]="this.disabled"
                  [class.param-changed]="this.isChanged('enabled')"
                  [attr.data-element]="'maven-side-enable-' + this.side"
                  (onValueChanged)="this.onEnabledChanged($event)"></dx-check-box>
    <span class="side-chevron"
          [class.dx-icon-chevronup]="this.expanded"
          [class.dx-icon-chevrondown]="!this.expanded"
          [attr.data-element]="'maven-side-toggle-' + this.side"
          (click)="this.toggleExpanded()"></span>
  </div>

  <!-- THE BREADCRUMB CRADLE (owner vrequest 2026-09-15): while folded, chips saying what this side
       holds; an unchecked side reads "Not Set". The strip unfolds the body only — the checkbox
       is never touched, exactly as the chevron. -->
  <div class="crumbs" *ngIf="!this.expanded"
       [attr.data-element]="'maven-crumbs-' + this.side"
       (click)="this.setExpanded(true)">
    <span class="chip" [class.changed]="this.chipChanged(c)" *ngFor="let c of this.crumbs">{{ c.text }}</span>
  </div>

  <div class="side-body" *ngIf="this.expanded">
    <ets-hedge-preset-selector [underlying]="targetInstrument?.ticker" [side]="side" [apgSource]="presetApgSource" layout="vertical" [selection]="inputs" [disabled]="disabled" (changed)="changed.emit()"></ets-hedge-preset-selector>
    <ng-container *ngIf="inputs?.mode !== 'preset'">

    <!-- S8 — coverage, FIRST (vrequest 2026-09-13, item 15: "coverage above the offset").
         Three kinds; Expected Range is DISABLED IN PLACE, never removed. -->
    <div class="field">
      <label>Coverage<span class="required" *ngIf="this.enabled && this.coverageMissing"
                           [attr.data-element]="'maven-required-coverage-' + this.side">*</span></label>
      <dx-button-group [items]="this.coverageItems"
                       keyExpr="id"
                       selectionMode="single"
                       stylingMode="contained"
                       [disabled]="this.disabled"
                       [class.param-changed]="this.isChanged('coverage.kind')"
                       [selectedItemKeys]="this.coverageKeys"
                       [attr.data-element]="'maven-coverage-' + this.side"
                       (onItemClick)="this.onCoverageClick($event)"></dx-button-group>
      <p class="note" [attr.data-element]="'maven-anchor-hint-' + this.side">{{ this.anchorHint }}</p>
    </div>

    <!-- The Range input selector comes first on both sides, before their numeric fields. -->
    <div class="field" *ngIf="this.isRangeCoverage">
      <dx-button-group [items]="this.rangeModeButtons"
                       keyExpr="id"
                       selectionMode="single"
                       stylingMode="contained"
                       [disabled]="this.disabled"
                       [class.param-changed]="this.isChanged('coverage.rangeMode')"
                       [selectedItemKeys]="this.rangeModeKeys"
                       [attr.data-element]="'maven-range-mode-' + this.side"
                       (onItemClick)="this.onRangeModeClick($event)"></dx-button-group>
    </div>

    <!-- Calls read upward (end strike/distance, then offset); Puts read downward (offset,
         then end strike/distance). Keyboard navigation follows the same field order. -->
    <ng-container [ngTemplateOutlet]="this.side === 'calls' ? endStrikeField : offsetField"></ng-container>
    <ng-container [ngTemplateOutlet]="this.side === 'calls' ? offsetField : endStrikeField"></ng-container>

    <ng-template #endStrikeField>
    <!-- There is no start box: the backend uses the adjusted short strike plus offset.
         Fixed ends keep the platform strike picker; distance uses a points number box. -->
    <div class="field" *ngIf="this.isRangeCoverage">
      <div class="range-value" *ngIf="!this.isDistanceRange">
        <label>End strike<span class="required" *ngIf="this.enabled && this.endStrikeMissing"
                             [attr.data-element]="'maven-required-end-strike-' + this.side">*</span></label>
        <ets-strikes-dropdown [strike]="this.endStrike"
                            [targetInstrument]="this.targetInstrument"
                            [expiration]="this.strikeExpiration"
                            [disable]="this.disabled"
                            [showClearButton]="true"
                            [class.param-changed]="this.isChanged('coverage.endStrike')"
                            [attr.data-element]="'maven-end-strike-' + this.side"
                            (strikeChange)="this.onEndStrikeChanged($event)"></ets-strikes-dropdown>
      </div>
      <div class="range-value" *ngIf="this.isDistanceRange">
        <label>Distance (points)<span class="required" *ngIf="this.enabled && this.rangeSizeMissing"
                                      [attr.data-element]="'maven-required-range-size-' + this.side">*</span></label>
        <dx-number-box [value]="this.rangeSize"
                       [showSpinButtons]="true"
                       [step]="this.strikeStep"
                       [disabled]="this.disabled"
                       [class.param-changed]="this.isChanged('coverage.rangeSize')"
                       placeholder="points"
                       [attr.data-element]="'maven-range-size-' + this.side"
                       (onValueChanged)="this.onRangeSizeChanged($event)"></dx-number-box>
      </div>
    </div>

    </ng-template>

    <ng-template #offsetField>
    <!-- S7 — offset from shorts, in POINTS, per side — so no dollar mask. It spins and snaps in
         multiples of the underlying's strike step (SPX 5, default 1), exactly as the ORION (OPG)
         offset box does (owner, vrequest 2026-09-13 round 3).
         NO valueChangeEvent="keyup" here (2026-09-14): this box commits on blur / Enter, like the
         OPG's. With keyup, every partial keystroke was snapped — typing "30" on SPX snapped the
         "3" to 5, the box redrew "5", and the "0" made it 50. The snap must see the whole number. -->
    <div class="field">
      <label>Offset from shorts<span class="required" *ngIf="this.enabled && this.offsetMissing"
                                     [attr.data-element]="'maven-required-offset-' + this.side">*</span></label>
      <dx-number-box [value]="this.offset"
                     [showSpinButtons]="true"
                     [step]="this.strikeStep"
                     [disabled]="this.disabled"
                     [class.param-changed]="this.isChanged('offset')"
                     placeholder="points"
                     [attr.data-element]="'maven-offset-' + this.side"
                     (onValueChanged)="this.onOffsetChanged($event)"></dx-number-box>
    </div>

    </ng-template>

    <!-- S6 — the cushion, normalized or raw. Flipping the mode converts the number in place so it
         keeps saying the same thing. Dollar-masked as the ORION (OPG)'s own box is
         (opg-side-questionnaire.component.html: format="$#,##0"). -->
    <div class="field">
      <label>Minimum profit<span class="required" *ngIf="this.enabled && this.minProfitMissing"
                                 [attr.data-element]="'maven-required-min-profit-' + this.side">*</span></label>
      <dx-button-group [items]="this.moneyModeButtons"
                       keyExpr="id"
                       selectionMode="single"
                       stylingMode="contained"
                       [disabled]="this.disabled"
                       [class.param-changed]="this.isChanged('minProfit.mode')"
                       [selectedItemKeys]="this.minProfitModeKeys"
                       [attr.data-element]="'maven-min-profit-mode-' + this.side"
                       (onItemClick)="this.onMinProfitModeClick($event)"></dx-button-group>
      <!-- valueChangeEvent="keyup": the typed number is COMMITTED AS TYPED, so a mode flip that
           follows it converts what the trader sees, not the box's last blurred value. This is
           what made the Normalized/Raw switch look dead (vrequest 2026-09-13, item 14). -->
      <dx-number-box [value]="this.minProfit"
                     [showSpinButtons]="true"
                     [disabled]="this.disabled"
                     format="$#,##0"
                     valueChangeEvent="keyup"
                     [class.param-changed]="this.isChanged('minProfit.amount')"
                     [attr.data-element]="'maven-min-profit-' + this.side"
                     (onValueChanged)="this.onMinProfitChanged($event)"></dx-number-box>
    </div>

    <!-- S9 — a dollar cap or one of the FOUR levels the ORION (OPG) offers. -->
    <div class="field">
      <label>Max risk<span class="required" *ngIf="this.enabled && this.riskMissing"
                           [attr.data-element]="'maven-required-risk-' + this.side">*</span></label>
      <dx-button-group [items]="this.riskKindButtons"
                       keyExpr="id"
                       selectionMode="single"
                       stylingMode="contained"
                       [disabled]="this.disabled"
                       [class.param-changed]="this.isChanged('maxRisk.kind')"
                       [selectedItemKeys]="this.riskKindKeys"
                       [attr.data-element]="'maven-risk-kind-' + this.side"
                       (onItemClick)="this.onRiskKindClick($event)"></dx-button-group>

      <dx-button-group *ngIf="this.isRelativeRisk"
                       [items]="this.riskLevelButtons"
                       keyExpr="id"
                       selectionMode="single"
                       stylingMode="contained"
                       [disabled]="this.disabled"
                       [class.param-changed]="this.isChanged('maxRisk.level')"
                       [selectedItemKeys]="this.riskLevelKeys"
                       [attr.data-element]="'maven-risk-level-' + this.side"
                       (onItemClick)="this.onRiskLevelClick($event)"></dx-button-group>

      <div class="risk-dollar" *ngIf="!this.isRelativeRisk">
        <dx-button-group [items]="this.moneyModeButtons"
                         keyExpr="id"
                         selectionMode="single"
                         stylingMode="contained"
                         [disabled]="this.disabled"
                         [class.param-changed]="this.isChanged('maxRisk.mode')"
                         [selectedItemKeys]="this.riskModeKeys"
                         [attr.data-element]="'maven-risk-mode-' + this.side"
                         (onItemClick)="this.onRiskModeClick($event)"></dx-button-group>
        <dx-number-box [value]="this.riskAmount"
                       [showSpinButtons]="true"
                       [disabled]="this.disabled"
                       format="$#,##0"
                       valueChangeEvent="keyup"
                       [class.param-changed]="this.isChanged('maxRisk.amount')"
                       [attr.data-element]="'maven-risk-amount-' + this.side"
                       (onValueChanged)="this.onRiskAmountChanged($event)"></dx-number-box>
      </div>
    </div>

    </ng-container>
    <!-- In place, under the block that caused it. The asterisks above say WHICH fields; the
         sentence says the side is not finished, or carries the backend's refusal. -->
    <p class="problem" *ngFor="let p of this.problems"
       [attr.data-element]="'maven-side-problem-' + this.side">{{ p }}</p>

  </div>

</div>
